import React, { useState, useRef, useEffect } from 'react';
import { Input, Space, Button, Popover } from 'antd';
import { SendOutlined, SmileOutlined } from '@ant-design/icons';

const EMOJIS = ['😀', '😂', '🤣', '😊', '😍', '🤔', '😎', '😭', '😡', '👍', '🙏', '❤️', '🔥', '✨', '👋', '👀'];

const MessageInput = ({ onSendMessage, onTyping }) => {
    const [text, setText] = useState('');
    const [isTypingLocal, setIsTypingLocal] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleChange = (e) => {
        const val = e.target.value;
        setText(val);
        
        if (!isTypingLocal && val.length > 0) {
            setIsTypingLocal(true);
            onTyping(true);
        } else if (isTypingLocal && val.length === 0) {
            setIsTypingLocal(false);
            onTyping(false);
        }
    };

    const handleSend = () => {
        if (!text.trim()) return;
        onSendMessage(text);
        setText('');
        setIsTypingLocal(false);
        onTyping(false);
    };

    const addEmoji = (emoji) => {
        setText(prev => prev + emoji);
        inputRef.current?.focus();
    };

    const emojiContent = (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
            {EMOJIS.map(e => (
                <div key={e} onClick={() => addEmoji(e)} style={{ cursor: 'pointer', fontSize: 20 }}>{e}</div>
            ))}
        </div>
    );

    return (
        <div style={{ borderTop: '1px solid #f0f0f0', padding: '15px 0 0 0' }}>
            <Space.Compact style={{ width: '100%' }}>
                <Popover content={emojiContent} trigger="click">
                    <Button icon={<SmileOutlined />} />
                </Popover>
                <Input 
                    ref={inputRef}
                    placeholder="Գրեք հաղորդագրություն..." 
                    value={text} 
                    onChange={handleChange}
                    onPressEnter={handleSend}
                />
                <Button type="primary" icon={<SendOutlined />} onClick={handleSend} />
            </Space.Compact>
        </div>
    );
};

export default MessageInput;